import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';
import resources from "../../api/resources";

export const getPensumsSelector = createSelector(
  pensum => pensum.pensumsById,
  (pensums) => getArrayOfObjectValues(pensums, resources.Pensum)
);